import type { RouteObject } from 'react-router';
import { EmptyState } from '@/components/ui';
import { page } from '@/lib/lazy-route';
import { portalMonitoringRoute } from '@/modules/monitoring/routes'; // Phase M (m-ui)

const pages = () => import('./pages');
const tickets = () => import('./tickets');
const catalog = () => import('./catalog');

// Customer portal (HaloPSA portal / Zendesk Help Center). Mounted at /portal with its own
// layout, for portal users only. Owned by the portal module.
export const portalRoutes: RouteObject[] = [
  {
    lazy: page(() => import('./layout'), (m) => m.PortalLayout),
    children: [
      { index: true, lazy: page(pages, (m) => m.PortalHomePage) },
      { path: 'tickets', lazy: page(tickets, (m) => m.PortalTicketsPage) },
      { path: 'tickets/new', lazy: page(tickets, (m) => m.PortalNewTicketPage) },
      { path: 'tickets/:id', lazy: page(tickets, (m) => m.PortalTicketPage) },
      // C9: service catalogue and approvals.
      { path: 'catalog', lazy: page(catalog, (m) => m.PortalCatalogPage) },
      { path: 'catalog/:id', lazy: page(catalog, (m) => m.PortalCatalogRequestPage) },
      { path: 'approvals', lazy: page(catalog, (m) => m.PortalApprovalsPage) },
      { path: 'articles', lazy: page(pages, (m) => m.PortalArticlesPage) },
      { path: 'articles/:id', lazy: page(pages, (m) => m.PortalArticlePage) },
      { path: 'invoices', lazy: page(pages, (m) => m.PortalInvoicesPage) },
      { path: 'invoices/:id', lazy: page(pages, (m) => m.PortalInvoicePage) },
      { path: 'assets', lazy: page(pages, (m) => m.PortalAssetsPage) },
      portalMonitoringRoute, // Phase M (m-ui): monitoring status for Portal Managers
      { path: '*', element: <EmptyState title="Page not found" description="Use the menu above to find what you need." /> },
    ],
  },
];
